<h1 mat-dialog-title>Delete {{type}} Logs</h1>
<div mat-dialog-content>
  <form [formGroup]="deleteForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col">
          <label class="formLabel" for="DELETE_DATE">*Delete Records Through</label>
      </div>
      <div class="col">
          <input type="date" formControlName="DELETE_DATE" (change)="getCrimeCount()">
      </div>
    </div>

    <div *ngIf="message" class="alert">{{message.text}}</div>

    <div mat-dialog-actions *ngIf="message">
      <button class="dialog-button" (click)="closeDialog()">No - Close</button>
      <button class="dialog-button" type="submit" [disabled]="!deleteForm.valid">Yes - Delete Records</button>
    </div>
  </form>
</div>
